module.exports = __webpack_public_path__ + "699d005153517ee4264615dd1e4e2b64.png";